<div [ngClass]="Theme">
    <div class="wrapper-tab-view" #content>
      <ng-content select="[tab-view-content]"></ng-content>
    </div>
  </div>  